import { jsx as _jsx } from "react/jsx-runtime";
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Step } from '../../views/Step';
import { StepTitle } from '../../views-components/StepTitle';
import { getIsMobile } from '../../utils/deviceUtils';
export const getHubOptionTitle = managementLevel => {
  const stepKey = Step.HubOption;
  const isMobile = getIsMobile();
  let i18nKey = `views.${stepKey}.title.${managementLevel}`;

  if (!isValidI18nKey(i18nKey) || isMobile) {
    i18nKey = `views.${stepKey}.title.default`;
  }

  return /*#__PURE__*/_jsx(StepTitle, {
    message: i18nKey,
    stepKey: stepKey
  });
};